import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { ConfigService } from '../config/config.service';
import { LoggingService } from '../loging/logging.service';
export class ContextService {
    title = 'ContextService';
private config: any;
    selectedCategory: BehaviorSubject<string> = new BehaviorSubject<string>('Most Trending Products');
/**
 * @param {?} configService
 * @param {?} loggingService
 */
constructor(
private configService: ConfigService,
private loggingService: LoggingService
    ) {
        this.loggingService.log('constructing ContextService')
        this.configService.getConfig((configuration:any) => {
            this.config = configuration;
        });
    }
/**
 * @param {?} newSelectedCategory
 * @return {?}
 */
setSelectedCategory(newSelectedCategory: string)
    {
        this.selectedCategory.next(newSelectedCategory);
    }


static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfigService, },
{type: LoggingService, },
];
}

function ContextService_tsickle_Closure_declarations() {
/** @type {?} */
ContextService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ContextService.ctorParameters;
/** @type {?} */
ContextService.prototype.title;
/** @type {?} */
ContextService.prototype.config;
/** @type {?} */
ContextService.prototype.selectedCategory;
/** @type {?} */
ContextService.prototype.configService;
/** @type {?} */
ContextService.prototype.loggingService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
